import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortColumnName',
  standalone: true,
})
export class SortColumnNamePipe implements PipeTransform {
  transform(columnKey: string): string {
    switch (columnKey) {
      case 'unit.name':
        return 'Unit';
      case 'unit.propertyName':
        return 'Property';
      case 'inspectionType':
        return 'Inspection';
      case 'dueDate':
        return 'Due Date';
      case 'status':
        return 'Status';
      case 'expiredAt':
        return 'Expiration';
      case 'completedAt':
        return 'Done';
      default:
        return columnKey;
    }
  }
}
